import { ActionInterface } from "../../../Interface/ActionInterface";
import Constants from "../../../Action/Constants";
import { FinancialStatementInterface } from "../../../Entity/Entities/FinancialStatement/FinancialStatementInterface";

interface StateInterface {
  byId: any;
  allIds: string[];
  requests: {};
  requestsOutdated: boolean;
  isFetching: boolean;
  financialStatement: any;
};

const initialState: StateInterface = {
  byId: {},
  allIds: [],
  requests: {},
  requestsOutdated: false,
  isFetching: false,
  financialStatement: null,
};

export const financialStatementsReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.GLOBAL_FINANCIAL_STATEMENTS_SAVE_LIST_SUCCESS:
    { 
      const request: string = action.payload?.request;
      let requests = !!state.requests ? {...state.requests} : {};
      const count: number = !!action.payload?.count ? action.payload?.count : 0;
      const financialStatements: FinancialStatementInterface[] = !!action.payload?.financialStatements ? action.payload?.financialStatements : [];

      requests[request] = {
        count: count,
        financialStatements: [...financialStatements]
      };

      return {
        ...state,
        requests: {...requests},
        requestsOutdated: false
      };
    }

    case Constants.FINANCIAL_STATEMENT_UPDATE_SUCCESS:
      return {
          ...state,
          isFetching: false,
          financialStatement: action.payload?.financialStatement,
        };

    case Constants.GLOBAL_FINANCIAL_STATEMENTS_LIST_OUTDATE_REQUESTS:
    {
      return {
        ...initialState,
        requestsOutdated: true
      };
    }

    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
